import { render, staticRenderFns } from "./BillingCompanyGroupIndex.vue?vue&type=template&id=4c72def6&scoped=true&"
import script from "./BillingCompanyGroupIndex.vue?vue&type=script&lang=js&"
export * from "./BillingCompanyGroupIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c72def6",
  null
  
)

export default component.exports